import { authenticatedUserStore } from '../stores'
import { Observer } from 'mobx-react'
import React, { Component } from 'react'
import { Unauthorized } from './index'

export default function authorize(ComponentToProtect, action) {
    return class extends Component {
        render() {
            return (
                <Observer>
                    {() => {
                        if (authenticatedUserStore.isAllowed(action))
                            return <ComponentToProtect {...this.props} />
                        else {
                            return <Unauthorized />
                        }
                    }}
                </Observer>
            )
        }
    }
}
